import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'

const Header: React.FC = () => {
  const navigate = useNavigate()
  const { user, profile, isAuthenticated, logout } = useAuthStore()
  const [showUserMenu, setShowUserMenu] = useState(false)

  const handleLogout = async () => {
    await logout()
    navigate('/')
    setShowUserMenu(false)
  }

  // DEBUG: Header rendered
  console.debug('Header rendered on page');
  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="flex items-center">
              <div className="flex items-center justify-center mr-3 px-4 py-2">
                <img
                  src="/logo.svg"
                  alt="TyreLink Logo"
                  className="max-h-[60px] w-auto object-contain mx-auto"
                  style={{ display: 'block' }}
                />
              </div>
            </div>
          </Link>

          {/* Navigation & User Menu */}
          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <>
                {/* Quick Actions */}
                <div className="hidden md:flex items-center space-x-4">
                  <Link
                    to="/search"
                    className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                  >
                    Search Tyres
                  </Link>
                  <Link
                    to="/fitment-centres"
                    className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                  >
                    Find Fitment Center
                  </Link>
                  {profile?.role === 'business' && (
                    <Link
                      to="/business"
                      className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                    >
                      Dashboard
                    </Link>
                  )}
                </div>

                {/* User Menu */}
                <div className="relative">
                  <button
                    onClick={() => setShowUserMenu(!showUserMenu)}
                    className="flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center">
                      <span className="text-sm font-medium text-white">
                        {user?.email?.charAt(0).toUpperCase()}
                      </span>
                    </div>
                    <div className="ml-3 hidden md:block">
                      <div className="text-sm font-medium text-gray-900">
                        {profile?.full_name || user?.email?.split('@')[0]}
                      </div>
                      <div className="text-xs text-gray-500 capitalize">
                        {profile?.role || 'User'}
                      </div>
                    </div>
                    <svg className="ml-2 h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  {showUserMenu && (
                    <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                      <div className="py-1">
                        <Link
                          to="/profile"
                          onClick={() => setShowUserMenu(false)}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          Profile Settings
                        </Link>
                        {profile?.role === 'customer' && (
                          <Link
                            to="/bookmarks"
                            onClick={() => setShowUserMenu(false)}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          >
                            My Shops
                          </Link>
                        )}
                        {profile?.role === 'business' && (
                          <Link
                            to="/business"
                            onClick={() => setShowUserMenu(false)}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          >
                            Business Dashboard
                          </Link>
                        )}
                        <div className="border-t border-gray-100"></div>
                        <button
                          onClick={handleLogout}
                          className="block w-full text-left px-4 py-2 text-sm text-red-700 hover:bg-red-50"
                        >
                          Sign out
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="flex items-center space-x-4">
                <Link
                  to="/#chat"
                  className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  Sign in
                </Link>
                <Link
                  to="/#chat"
                  className="bg-black text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors"
                >
                  Get Started
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile User Info */}
      {isAuthenticated && (
        <div className="md:hidden bg-gray-50 border-t border-gray-200 px-4 py-3">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center mr-3">
              <span className="text-sm font-medium text-white">
                {user?.email?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div>
              <div className="text-sm font-medium text-gray-900">
                {profile?.full_name || user?.email?.split('@')[0]}
              </div>
              <div className="text-xs text-gray-500 capitalize">
                {profile?.role || 'User'}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}

export default Header
